export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      specialties: 'Specialties',
      specialists: 'Specialists',
      patients: 'Patients',
      contact: 'Contact Us',
      menu: 'Menu',
    },
    hero: {
      slide1: {
        title: 'SU SALUD ES NUESTRA PRIORIDAD',
        subtitle:
          'A world-class ambulatory surgical center providing advanced infrastructure for independent specialists and exceptional care for patients.',
        btnPatient: 'I Am a Patient',
        btnSpecialist: 'I Am a Specialist',
      },
      slide2: {
        title: 'Modern Medical Infrastructure',
        subtitle:
          'State-of-the-art operating rooms equipped with advanced technology for diverse surgical procedures.',
      },
      slide3: {
        title: 'Comfort and Care',
        subtitle:
          'Private hospitalization rooms designed for patient recovery and family comfort in a calm environment.',
      },
      slide4: {
        title: 'Institutional Surgical Coordination',
        subtitle:
          'Seamless organization and professional support for every surgical procedure.',
      },
      slide5: {
        title: 'International Patient Care',
        subtitle:
          'Dedicated assistance and coordination for patients traveling from abroad for surgical care.',
      },
    },
    home: {
      stats: {
        rooms: 'Hospitalization Rooms',
        operation: 'Operation',
        specialties: 'Surgical Specialties',
        reach: 'International Reach',
      },
      about: {
        title: 'Excellence in Ambulatory Surgery',
        subtitle:
          'We provide a safe, modern, and efficient environment for surgical procedures.',
        p1: 'CACES is a premier private ambulatory surgical center in San Salvador. We are dedicated to providing state-of-the-art infrastructure for independent medical specialists to perform surgeries with the highest standards of safety and quality.',
        p2: 'Our model focuses on operational excellence, allowing surgeons to focus on what they do best: caring for patients. With 7 private rooms and fully equipped operating theaters, we ensure a comfortable and professional experience.',
        btn: 'Learn More About CACES',
        imgLabel: 'Modern Operating Facilities',
      },
      facilities: {
        title: 'World-Class Infrastructure',
        subtitle: 'Designed for safety, comfort, and efficiency.',
        or: {
          title: 'Operating Rooms',
          desc: 'Fully equipped with advanced technology for diverse surgical procedures.',
        },
        recovery: {
          title: 'Recovery Area',
          desc: 'Monitored post-operative care ensuring patient stability and safety.',
        },
        suites: {
          title: 'Private Suites',
          desc: '7 comfortable hospitalization rooms for patient recovery and family comfort.',
        },
      },
      specialties: {
        title: 'Surgical Specialties',
        subtitle: 'Supporting a wide range of surgical disciplines.',
        viewAll: 'View All Specialties',
      },
      videos: {
        title: 'Inside Our Facilities',
        subtitle:
          'A closer look at our institutional processes and surgical environment.',
        disclaimer:
          'The following content is presented for institutional and educational purposes only. No clinical outcomes are implied.',
        items: [
          {
            caption: 'Operating Room Preparation Process',
            videoId: 'dQw4w9WgXcQ',
          },
          {
            caption: 'Institutional Surgical Workflow',
            videoId: 'dQw4w9WgXcQ',
          },
          {
            caption: 'Modern Surgical Infrastructure',
            videoId: 'dQw4w9WgXcQ',
          },
        ],
      },
      cta: {
        title: 'Ready to Schedule a Procedure?',
        desc: 'Whether you are a patient looking for care or a specialist seeking a facility, our team is here to coordinate your needs.',
        btn: 'Request Surgical Coordination',
      },
      enhanced: {
        highlights: {
          title: 'Why Choose CACES',
          items: [
            { title: '24/7 Surgical Availability' },
            { title: 'Certified Surgical Facilities' },
            { title: 'Dedicated Recovery Areas' },
            { title: 'Institutional Clinical Support' },
          ],
        },
        process: {
          title: 'How It Works',
          subtitle: 'A streamlined surgical process from start to finish.',
          steps: [
            {
              title: 'Surgical Coordination',
              desc: 'Scheduling, preparation, and institutional alignment.',
            },
            {
              title: 'Procedure & Hospitalization',
              desc: 'Surgery in fully equipped operating rooms with 24/7 support.',
            },
            {
              title: 'Post-Operative Recovery',
              desc: 'Monitored recovery in private hospitalization rooms.',
            },
          ],
        },
        support: {
          title: 'Clinical & Administrative Support',
          subtitle: 'Comprehensive institutional backing for every procedure.',
          items: [
            'Nursing support',
            'Surgical instrumentation',
            'Sterilization protocols',
            'Administrative coordination',
            'Scheduling assistance',
            'Insurance processing',
          ],
        },
        facilities: {
          title: 'Our Facilities',
          stats: [
            { value: '7', label: 'Private Hospitalization Rooms' },
            { value: '24/7', label: 'Continuous Operation' },
            { value: '3', label: 'Dedicated Surgical Areas' },
          ],
        },
        nav: {
          title: 'Discover More About CACES',
          subtitle:
            'Learn about our institution, infrastructure, and commitment to surgical excellence.',
          btnAbout: 'Learn More About CACES',
          btnFacilities: 'Explore Our Facilities',
        },
      },
    },
    about: {
      hero: {
        title: 'About CACES',
        subtitle:
          'Setting the standard for ambulatory surgical care in El Salvador.',
      },
      who: {
        title: 'Who We Are',
        p1: 'Centro Ambulatorio de Cirugía Escalón (CACES) is a private institution dedicated to providing high-quality infrastructure and support services for ambulatory surgeries. Located in the heart of San Salvador, we serve as a hub for independent medical specialists and their patients.',
        p2: 'Our mission is to prioritize health by offering a safe, sterile, and efficient environment where surgeons can perform complex procedures with the backing of a professional clinical and administrative team.',
      },
      model: {
        title: 'Our Medical Care Model',
        subtitle: 'A partnership between institution and specialist.',
        specialists: {
          title: 'Affiliated Specialists',
          desc: 'CACES does not employ physicians directly. Instead, we partner with independent, highly qualified specialists who utilize our facilities to treat their patients.',
        },
        support: {
          title: 'Institutional Support',
          desc: 'We provide the "stage" for the surgery: operating rooms, nursing staff, hospitalization rooms, and administrative coordination, ensuring seamless operations.',
        },
        patient: {
          title: 'Patient Focus',
          desc: 'Our model ensures that patients receive personalized care from their chosen surgeon while benefiting from the safety and standards of a top-tier institution.',
        },
      },
      infra: {
        title: 'Infrastructure & Facilities',
        suites: {
          title: 'Surgical Suites',
          desc: 'Our operating rooms are equipped with modern surgical technology, advanced lighting, and anesthesia monitoring systems. We maintain rigorous sterilization protocols to ensure patient safety at all times.',
        },
        rooms: {
          title: 'Private Hospitalization',
          desc: 'We offer 7 private hospitalization rooms designed for comfort and recovery. Each room features monitoring equipment, a private bathroom, and space for a companion, ensuring a dignified and restful recovery experience.',
        },
      },
      management: {
        title: 'Presidency & Management',
        desc: 'CACES is led by an institutional management team focused on operational excellence, quality assurance, and strategic growth. Our leadership ensures that the center remains a premier destination for ambulatory surgery in the region.',
        note: 'Note: All clinical decisions are made by the treating independent specialists.',
      },
    },
    services: {
      hero: {
        title: 'Our Services',
        subtitle:
          'Comprehensive surgical and support services for patients and specialists.',
      },
      items: {
        hospitalization: {
          title: 'Hospitalization',
          desc: '7 private rooms designed for comfort and safety, with 24/7 nursing care and monitoring for post-surgical recovery.',
        },
        preop: {
          title: 'Pre-operative Preparation',
          desc: 'Comprehensive patient assessment and preparation protocols to ensure readiness for surgical procedures.',
        },
        postop: {
          title: 'Post-operative Recovery',
          desc: 'Dedicated recovery areas with continuous vital sign monitoring and specialized nursing oversight immediately after surgery.',
        },
        or: {
          title: 'Operating Room',
          desc: 'State-of-the-art surgical suites equipped with modern anesthesia machines, lighting, and sterile instrumentation.',
        },
        clinical: {
          title: 'Clinical Support',
          desc: 'Coordination of laboratory tests, imaging, and pharmacy services to support the surgical process.',
        },
        admin: {
          title: 'Administrative Support',
          desc: 'Full assistance with insurance coordination, billing, medical documentation, and scheduling.',
        },
      },
      cta: {
        title: 'Schedule Your Procedure',
        desc: 'Our coordination team is ready to assist you with scheduling, insurance verification, and pre-operative requirements.',
        btn: 'Contact Coordination Team',
      },
      enhanced: {
        highlights: {
          title: 'Why Choose CACES',
          items: [
            { title: '24/7 Surgical Availability' },
            { title: 'Certified Surgical Facilities' },
            { title: 'Dedicated Recovery Areas' },
            { title: 'Institutional Clinical Support' },
          ],
        },
        process: {
          title: 'How It Works',
          subtitle: 'A streamlined surgical process from start to finish.',
          steps: [
            {
              title: 'Surgical Coordination',
              desc: 'Scheduling, preparation, and institutional alignment.',
            },
            {
              title: 'Procedure & Hospitalization',
              desc: 'Surgery in fully equipped operating rooms with 24/7 support.',
            },
            {
              title: 'Post-Operative Recovery',
              desc: 'Monitored recovery in private hospitalization rooms.',
            },
          ],
        },
        support: {
          title: 'Clinical & Administrative Support',
          subtitle: 'Comprehensive institutional backing for every procedure.',
          items: [
            'Nursing support',
            'Surgical instrumentation',
            'Sterilization protocols',
            'Administrative coordination',
            'Scheduling assistance',
            'Insurance processing',
          ],
        },
        facilities: {
          title: 'Our Facilities',
          stats: [
            { value: '7', label: 'Private Hospitalization Rooms' },
            { value: '24/7', label: 'Continuous Operation' },
            { value: '3', label: 'Dedicated Surgical Areas' },
          ],
        },
        nav: {
          title: 'Discover More About CACES',
          subtitle:
            'Learn about our institution, infrastructure, and commitment to surgical excellence.',
          btnAbout: 'Learn More About CACES',
          btnFacilities: 'Explore Our Facilities',
        },
      },
    },
    specialties: {
      hero: {
        title: 'Surgical Specialties',
        subtitle: 'Expert care across a wide range of surgical disciplines.',
      },
      items: {
        general: {
          name: 'General Surgery',
          desc: 'Comprehensive surgical procedures for a wide range of abdominal and general conditions.',
        },
        laparoscopic: {
          name: 'Laparoscopic Surgery',
          desc: 'Minimally invasive surgical techniques using small incisions for faster recovery and less scarring.',
        },
        urological: {
          name: 'Urological Surgery',
          desc: 'Surgical treatment of conditions affecting the urinary tract and male reproductive system.',
        },
        colorectal: {
          name: 'Colorectal Surgery',
          desc: 'Specialized procedures for disorders of the rectum, anus, and colon.',
        },
        oncological: {
          name: 'Oncological Surgery',
          desc: 'Surgical treatment and removal of tumors and cancerous tissues.',
        },
        orthopedic: {
          name: 'Orthopedic Surgery',
          desc: 'Surgical care for musculoskeletal conditions, including bones, joints, ligaments, and tendons.',
        },
        ent: {
          name: 'Otolaryngology Surgery',
          desc: 'Surgical procedures for conditions of the ear, nose, and throat (ENT).',
        },
      },
      inquire: 'Inquire about this specialty',
      disclaimer:
        'Important Note: All surgical procedures at CACES are performed by independent affiliated specialists. CACES provides the facility, equipment, and support staff, but clinical decisions are the responsibility of your chosen surgeon.',
    },
    specialists: {
      hero: {
        title: 'Medical Specialists',
        subtitle:
          'Work with highly qualified independent professionals affiliated with CACES.',
      },
      intro:
        'CACES works with a network of trusted specialists who utilize our facilities to provide exceptional care. Browse our affiliated professionals below.',
      btn: 'Request Coordination',
      disclaimer: {
        title: 'Important Disclaimer',
        text: 'Medical specialists featured are independent professionals affiliated with CACES. They are not employees of CACES. All communication and surgical coordination is handled exclusively through CACES to ensure streamlined service.',
      },
      join: {
        title: 'Are you a Medical Specialist?',
        desc: 'Join our network of affiliated professionals and operate in one of the most modern ambulatory centers in the region.',
        btn: 'Learn About Operating at CACES',
      },
    },
    patients: {
      hero: {
        title: 'Patient Information',
        subtitle: 'Everything you need to know about your experience at CACES.',
      },
      journey: {
        title: 'Your Experience at CACES',
        subtitle: 'A streamlined journey from consultation to recovery.',
        steps: {
          consultation: {
            title: 'Consultation',
            desc: 'Initial evaluation with your specialist.',
          },
          coordination: {
            title: 'Coordination',
            desc: 'Scheduling and insurance verification with CACES.',
          },
          preparation: {
            title: 'Preparation',
            desc: 'Pre-operative instructions and arrival.',
          },
          surgery: {
            title: 'Surgery',
            desc: 'Procedure in our modern operating rooms.',
          },
          recovery: {
            title: 'Recovery',
            desc: 'Monitored recovery and discharge.',
          },
        },
      },
      visualJourney: {
        title: 'Preparing for Your Procedure',
        subtitle:
          'A calm, organized journey from your first contact to recovery.',
        steps: [
          {
            title: 'Initial Contact',
            desc: 'Coordinated medical care from the start.',
          },
          {
            title: 'Pre-Surgical Evaluation',
            desc: 'A thorough review in a calm clinical setting.',
          },
          {
            title: 'Day of Admission',
            desc: 'A safe and organized environment awaits you.',
          },
          {
            title: 'Pre-Operative Preparation',
            desc: 'Calm preparation before your procedure.',
          },
          {
            title: 'Post-Surgery Recovery',
            desc: 'Comfort and supervision during your recovery.',
          },
        ],
      },
      international: {
        title: 'International Patients',
        desc: 'CACES welcomes patients from around the world. We understand the unique needs of medical travel and offer dedicated assistance to ensure a smooth experience.',
        list: [
          'Remote coordination with specialists',
          'Scheduling flexibility',
          'Bilingual staff support',
        ],
      },
      prep: {
        title: 'Preparing for Surgery',
        subtitle: 'General Guidelines',
        list: [
          'Follow fasting instructions provided by your specialist.',
          'Bring a valid ID and insurance documentation.',
          'Arrange for a companion to drive you home after discharge.',
          'Wear comfortable, loose-fitting clothing.',
          'Leave valuables and jewelry at home.',
          'Bring a list of current medications.',
        ],
      },
      faq: {
        title: 'Frequently Asked Questions',
        items: [
          {
            q: 'What is CACES?',
            a: 'CACES (Centro Ambulatorio de Cirugía Escalón) is a private ambulatory surgical center that provides high-quality facilities and support staff for surgical procedures performed by independent affiliated specialists.',
          },
          {
            q: 'Do I choose my surgeon?',
            a: 'Yes, you select your specialist. CACES coordinates the surgical logistics, facility usage, and nursing support, but the medical relationship remains between you and your chosen doctor.',
          },
          {
            q: 'How long will I stay?',
            a: 'Most procedures at CACES are ambulatory, meaning you go home the same day. However, we have 7 private rooms for short-term hospitalization if your procedure or specialist requires it.',
          },
          {
            q: 'Is CACES open 24/7?',
            a: 'Yes, CACES operates 24 hours a day, 7 days a week to support scheduled surgeries and post-operative recovery.',
          },
          {
            q: 'How do I schedule a procedure?',
            a: 'You can contact our coordination team directly through this website or by phone. We will guide you through the process in coordination with your specialist.',
          },
          {
            q: 'Do you accept international patients?',
            a: 'Yes, we welcome international patients and provide assistance with coordination, including scheduling and local logistics guidance.',
          },
        ],
      },
    },
    contact: {
      hero: {
        title: 'Contact Us',
        subtitle: 'We are here to assist you 24/7.',
      },
      form: {
        title: 'Send us a Message',
        name: 'Full Name',
        namePh: 'Your name',
        email: 'Email',
        emailPh: 'your@email.com',
        phone: 'Phone',
        phonePh: '+503 ...',
        subject: 'Subject',
        message: 'Message',
        messagePh: 'How can we help you?',
        btn: 'Send Message',
        success: {
          title: 'Message Sent',
          desc: 'Thank you for contacting CACES. We will respond to your inquiry as soon as possible.',
        },
        subjects: {
          patient: 'Patient Inquiry',
          coordination: 'Surgical Coordination',
          specialist: 'Specialist Inquiry',
          general: 'General Information',
        },
      },
      info: {
        title: 'Contact Information',
        address: 'Address',
        phone: 'Phone',
        phoneDesc: 'Available 24/7 for coordination',
        email: 'Email',
        hours: 'Hours',
        hoursDesc: 'Open 24 Hours / 7 Days a Week',
        map: 'Map Integration Placeholder',
      },
    },
    footer: {
      desc: 'Centro Ambulatorio de Cirugía Escalón. Your health is our priority. We provide world-class facilities for independent specialists to perform advanced surgical procedures.',
      operating: 'Operating 24/7',
      quickLinks: 'Quick Links',
      services: 'Medical Services',
      contact: 'Contact Us',
      rights: 'All rights reserved.',
      disclaimer:
        'Disclaimer: CACES is an ambulatory surgical center. Medical specialists are independent affiliated professionals and not employees of CACES.',
    },
    modal: {
      title: 'Request Surgical Coordination',
      success: {
        title: 'Request Received',
        desc: 'Thank you for contacting CACES. Our coordination team will review your request and contact you shortly.',
        close: 'Close',
      },
      form: {
        name: 'Full Name',
        namePh: 'Enter your full name',
        email: 'Email',
        emailPh: 'your@email.com',
        phone: 'Phone',
        phonePh: '+503 ...',
        specialty: 'Specialty of Interest',
        message: 'Message',
        messagePh: 'How can we help you?',
        note: 'Note: CACES is an ambulatory surgical center. Medical specialists are independent affiliated professionals.',
        submit: 'Submit Request',
        options: {
          general: 'General Surgery',
          laparoscopic: 'Laparoscopic Surgery',
          urological: 'Urological Surgery',
          colorectal: 'Colorectal Surgery',
          oncological: 'Oncological Surgery',
          orthopedic: 'Orthopedic Surgery',
          ent: 'Otolaryngology Surgery',
          other: 'Other / General Inquiry',
        },
      },
    },
    specialistForm: {
      title: 'CACES Surgical Platform – Specialist Coordination Portal',
      subtitle:
        'CACES provides a fully equipped ambulatory surgical environment for independent medical specialists. Use this institutional portal to coordinate surgical procedures within our certified facility.',
      success: {
        title: 'Request Received',
        desc: 'Thank you. Your surgical coordination request has been received by the CACES administrative team. Our team will contact you shortly to confirm details and availability.',
        close: 'Close',
      },
      section1: {
        title: 'I. Professional Credentials',
        name: 'Full Name',
        namePh: 'Enter your full name',
        license: 'Professional License / Medical ID Number',
        licensePh: 'Enter your license or medical ID',
        specialty: 'Specialty',
        institution: 'Institution or Clinic of Origin',
        institutionPh: 'Hospital, clinic, or private practice (optional)',
        email: 'Email Address',
        emailPh: 'your@email.com',
        phone: 'Phone Number',
        phonePh: '+503 ...',
        requestType: 'Type of Request',
        requestTypeOptions: {
          placeholder: 'Select type of request',
          firstTime: 'First-time surgical coordination',
          returning: 'Returning specialist',
          regular: 'Interested in regular surgical access',
        },
      },
      section2: {
        title: 'II. Surgical Planning',
        surgicalSpecialty: 'Surgical Specialty to Coordinate',
        procedure: 'Procedure Name or Description',
        procedurePh: 'Describe the surgical procedure',
        duration: 'Estimated Procedure Duration',
        durationPh: 'e.g., 2 hours',
        durationOptions: {
          placeholder: 'Select estimated duration',
          under1: 'Under 1 hour',
          one2: '1–2 hours',
          two3: '2–3 hours',
          three4: '3–4 hours',
          over4: 'Over 4 hours',
        },
        date: 'Preferred Surgery Date',
        hospitalization: 'Estimated Hospitalization Days',
        hospitalizationPh: 'Number of days',
        hospitalizationNote:
          'CACES operates as an ambulatory surgical center. Extended hospitalization requires prior authorization.',
      },
      section3: {
        title: 'III. Technical & Institutional Requirements',
        requirements: 'Special Requirements or Observations',
        requirementsPh: 'Any special equipment, staff, or conditions needed...',
        documents: 'Attach Relevant Documents',
        documentsNote:
          'e.g., medical notes, procedure details — no patient identifiers required',
        documentsBtn: 'Choose File',
        noFile: 'No file selected',
        reviewNote:
          'Our surgical coordination team reviews all technical requirements to ensure full operating room readiness.',
      },
      section4: {
        title: 'IV. Institutional Confirmation',
        checkbox:
          'I confirm that I am an independent medical specialist and understand that all clinical decisions remain under my exclusive professional responsibility. CACES provides infrastructure, surgical equipment, and certified clinical support teams.',
      },
      whyOperate: {
        title: 'Why Operate at CACES?',
        items: [
          'Fully equipped operating rooms',
          'Certified surgical support teams',
          'Ambulatory surgical efficiency',
          'Institutional safety protocols',
          'Professional autonomy respected',
        ],
      },
      submit: 'Submit Institutional Surgical Request',
      note: 'CACES is an ambulatory surgical center. All procedures are performed by independent medical specialists who retain full clinical responsibility. CACES provides infrastructure, equipment, and surgical support teams.',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Acerca de',
      services: 'Servicios',
      specialties: 'Especialidades',
      specialists: 'Especialistas',
      patients: 'Pacientes',
      contact: 'Contáctenos',
      menu: 'Menú',
    },
    hero: {
      slide1: {
        title: 'SU SALUD ES NUESTRA PRIORIDAD',
        subtitle:
          'Un centro de cirugía ambulatoria de clase mundial que ofrece infraestructura avanzada para especialistas independientes y atención excepcional para pacientes.',
        btnPatient: 'Soy Paciente',
        btnSpecialist: 'Soy Médico Especialista',
      },
      slide2: {
        title: 'Infraestructura Médica Moderna',
        subtitle:
          'Quirófanos de última generación equipados con tecnología avanzada para diversos procedimientos quirúrgicos.',
      },
      slide3: {
        title: 'Comodidad y Cuidado',
        subtitle:
          'Habitaciones privadas de hospitalización diseñadas para la recuperación del paciente y la comodidad familiar en un ambiente tranquilo.',
      },
      slide4: {
        title: 'Coordinación Quirúrgica Institucional',
        subtitle:
          'Organización perfecta y apoyo profesional para cada procedimiento quirúrgico.',
      },
      slide5: {
        title: 'Atención a Pacientes Internacionales',
        subtitle:
          'Asistencia y coordinación dedicada para pacientes que viajan desde el extranjero para atención quirúrgica.',
      },
    },
    home: {
      stats: {
        rooms: 'Habitaciones',
        operation: 'Operación',
        specialties: 'Especialidades',
        reach: 'Alcance Internacional',
      },
      about: {
        title: 'Excelencia en Cirugía Ambulatoria',
        subtitle:
          'Brindamos un entorno seguro, moderno y eficiente para procedimientos quirúrgicos.',
        p1: 'CACES es un centro de cirugía ambulatoria privado de primer nivel en San Salvador. Nos dedicamos a proporcionar infraestructura de vanguardia para que especialistas médicos independientes realicen cirugías con los más altos estándares de seguridad y calidad.',
        p2: 'Nuestro modelo se centra en la excelencia operativa, permitiendo a los cirujanos concentrarse en lo que mejor saben hacer: cuidar a los pacientes. Con 7 habitaciones privadas y quirófanos totalmente equipados, garantizamos una experiencia cómoda y profesional.',
        btn: 'Más Información sobre CACES',
        imgLabel: 'Instalaciones Quirúrgicas Modernas',
      },
      facilities: {
        title: 'Infraestructura de Clase Mundial',
        subtitle: 'Diseñada para seguridad, comodidad y eficiencia.',
        or: {
          title: 'Quirófanos',
          desc: 'Totalmente equipados con tecnología avanzada para diversos procedimientos quirúrgicos.',
        },
        recovery: {
          title: 'Área de Recuperación',
          desc: 'Atención postoperatoria monitoreada que garantiza la estabilidad y seguridad del paciente.',
        },
        suites: {
          title: 'Suites Privadas',
          desc: '7 cómodas habitaciones de hospitalización para la recuperación del paciente y comodidad familiar.',
        },
      },
      specialties: {
        title: 'Especialidades Quirúrgicas',
        subtitle: 'Apoyando una amplia gama de disciplinas quirúrgicas.',
        viewAll: 'Ver Todas las Especialidades',
      },
      videos: {
        title: 'Dentro de Nuestras Instalaciones',
        subtitle:
          'Una mirada más cercana a nuestros procesos institucionales y entorno quirúrgico.',
        disclaimer:
          'El siguiente contenido se presenta únicamente con fines institucionales y educativos. No se implican resultados clínicos.',
        items: [
          {
            caption: 'Proceso de Preparación del Quirófano',
            videoId: 'dQw4w9WgXcQ',
          },
          {
            caption: 'Flujo de Trabajo Quirúrgico Institucional',
            videoId: 'dQw4w9WgXcQ',
          },
          {
            caption: 'Infraestructura Quirúrgica Moderna',
            videoId: 'dQw4w9WgXcQ',
          },
        ],
      },
      cta: {
        title: '¿Listo para Programar un Procedimiento?',
        desc: 'Ya sea que usted sea un paciente buscando atención o un especialista buscando una instalación, nuestro equipo está aquí para coordinar sus necesidades.',
        btn: 'Solicitar Coordinación Quirúrgica',
      },
      enhanced: {
        highlights: {
          title: 'Por Qué Elegir CACES',
          items: [
            { title: 'Disponibilidad Quirúrgica 24/7' },
            { title: 'Instalaciones Quirúrgicas Certificadas' },
            { title: 'Áreas de Recuperación Dedicadas' },
            { title: 'Apoyo Clínico Institucional' },
          ],
        },
        process: {
          title: 'Cómo Funciona',
          subtitle: 'Un proceso quirúrgico optimizado de principio a fin.',
          steps: [
            {
              title: 'Coordinación Quirúrgica',
              desc: 'Programación, preparación y alineación institucional.',
            },
            {
              title: 'Procedimiento y Hospitalización',
              desc: 'Cirugía en quirófanos totalmente equipados con soporte 24/7.',
            },
            {
              title: 'Recuperación Postoperatoria',
              desc: 'Recuperación monitoreada en habitaciones privadas de hospitalización.',
            },
          ],
        },
        support: {
          title: 'Apoyo Clínico y Administrativo',
          subtitle: 'Respaldo institucional integral para cada procedimiento.',
          items: [
            'Apoyo de enfermería',
            'Instrumentación quirúrgica',
            'Protocolos de esterilización',
            'Coordinación administrativa',
            'Asistencia de programación',
            'Procesamiento de seguros',
          ],
        },
        facilities: {
          title: 'Nuestras Instalaciones',
          stats: [
            { value: '7', label: 'Habitaciones Privadas de Hospitalización' },
            { value: '24/7', label: 'Operación Continua' },
            { value: '3', label: 'Áreas Quirúrgicas Dedicadas' },
          ],
        },
        nav: {
          title: 'Descubra Más Sobre CACES',
          subtitle:
            'Conozca nuestra institución, infraestructura y compromiso con la excelencia quirúrgica.',
          btnAbout: 'Más Información Sobre CACES',
          btnFacilities: 'Explore Nuestras Instalaciones',
        },
      },
    },
    about: {
      hero: {
        title: 'Acerca de CACES',
        subtitle:
          'Estableciendo el estándar para la atención quirúrgica ambulatoria en El Salvador.',
      },
      who: {
        title: 'Quiénes Somos',
        p1: 'El Centro Ambulatorio de Cirugía Escalón (CACES) es una institución privada dedicada a proporcionar infraestructura de alta calidad y servicios de apoyo para cirugías ambulatorias. Ubicados en el corazón de San Salvador, servimos como centro para especialistas médicos independientes y sus pacientes.',
        p2: 'Nuestra misión es priorizar la salud ofreciendo un entorno seguro, estéril y eficiente donde los cirujanos puedan realizar procedimientos complejos con el respaldo de un equipo clínico y administrativo profesional.',
      },
      model: {
        title: 'Nuestro Modelo de Atención Médica',
        subtitle: 'Una asociación entre institución y especialista.',
        specialists: {
          title: 'Especialistas Afiliados',
          desc: 'CACES no emplea médicos directamente. En su lugar, nos asociamos con especialistas independientes y altamente calificados que utilizan nuestras instalaciones para tratar a sus pacientes.',
        },
        support: {
          title: 'Apoyo Institucional',
          desc: 'Proporcionamos el "escenario" para la cirugía: quirófanos, personal de enfermería, habitaciones de hospitalización y coordinación administrativa, asegurando operaciones sin problemas.',
        },
        patient: {
          title: 'Enfoque en el Paciente',
          desc: 'Nuestro modelo garantiza que los pacientes reciban atención personalizada de su cirujano elegido mientras se benefician de la seguridad y los estándares de una institución de primer nivel.',
        },
      },
      infra: {
        title: 'Infraestructura e Instalaciones',
        suites: {
          title: 'Suites Quirúrgicas',
          desc: 'Nuestros quirófanos están equipados con tecnología quirúrgica moderna, iluminación avanzada y sistemas de monitoreo de anestesia. Mantenemos rigurosos protocolos de esterilización para garantizar la seguridad del paciente en todo momento.',
        },
        rooms: {
          title: 'Hospitalización Privada',
          desc: 'Ofrecemos 7 habitaciones privadas de hospitalización diseñadas para la comodidad y recuperación. Cada habitación cuenta con equipo de monitoreo, baño privado y espacio para un acompañante, asegurando una experiencia de recuperación digna y tranquila.',
        },
      },
      management: {
        title: 'Presidencia y Gestión',
        desc: 'CACES está dirigido por un equipo de gestión institucional enfocado en la excelencia operativa, el aseguramiento de la calidad y el crecimiento estratégico. Nuestro liderazgo asegura que el centro siga siendo un destino principal para la cirugía ambulatoria en la región.',
        note: 'Nota: Todas las decisiones clínicas son tomadas por los especialistas independientes tratantes.',
      },
    },
    services: {
      hero: {
        title: 'Nuestros Servicios',
        subtitle:
          'Servicios quirúrgicos y de apoyo integrales para pacientes y especialistas.',
      },
      items: {
        hospitalization: {
          title: 'Hospitalización',
          desc: '7 habitaciones privadas diseñadas para comodidad y seguridad, con atención de enfermería 24/7 y monitoreo para recuperación postquirúrgica.',
        },
        preop: {
          title: 'Preparación Preoperatoria',
          desc: 'Evaluación integral del paciente y protocolos de preparación para asegurar la preparación para procedimientos quirúrgicos.',
        },
        postop: {
          title: 'Recuperación Postoperatoria',
          desc: 'Áreas de recuperación dedicadas con monitoreo continuo de signos vitales y supervisión de enfermería especializada inmediatamente después de la cirugía.',
        },
        or: {
          title: 'Quirófano',
          desc: 'Suites quirúrgicas de última generación equipadas con máquinas de anestesia modernas, iluminación e instrumentación estéril.',
        },
        clinical: {
          title: 'Apoyo Clínico',
          desc: 'Coordinación de pruebas de laboratorio, imágenes y servicios de farmacia para apoyar el proceso quirúrgico.',
        },
        admin: {
          title: 'Apoyo Administrativo',
          desc: 'Asistencia completa con coordinación de seguros, facturación, documentación médica y programación.',
        },
      },
      cta: {
        title: 'Programe su Procedimiento',
        desc: 'Nuestro equipo de coordinación está listo para ayudarle con la programación, verificación de seguros y requisitos preoperatorios.',
        btn: 'Contactar Equipo de Coordinación',
      },
      enhanced: {
        highlights: {
          title: 'Por Qué Elegir CACES',
          items: [
            { title: 'Disponibilidad Quirúrgica 24/7' },
            { title: 'Instalaciones Quirúrgicas Certificadas' },
            { title: 'Áreas de Recuperación Dedicadas' },
            { title: 'Apoyo Clínico Institucional' },
          ],
        },
        process: {
          title: 'Cómo Funciona',
          subtitle: 'Un proceso quirúrgico optimizado de principio a fin.',
          steps: [
            {
              title: 'Coordinación Quirúrgica',
              desc: 'Programación, preparación y alineación institucional.',
            },
            {
              title: 'Procedimiento y Hospitalización',
              desc: 'Cirugía en quirófanos totalmente equipados con soporte 24/7.',
            },
            {
              title: 'Recuperación Postoperatoria',
              desc: 'Recuperación monitoreada en habitaciones privadas de hospitalización.',
            },
          ],
        },
        support: {
          title: 'Apoyo Clínico y Administrativo',
          subtitle: 'Respaldo institucional integral para cada procedimiento.',
          items: [
            'Apoyo de enfermería',
            'Instrumentación quirúrgica',
            'Protocolos de esterilización',
            'Coordinación administrativa',
            'Asistencia de programación',
            'Procesamiento de seguros',
          ],
        },
        facilities: {
          title: 'Nuestras Instalaciones',
          stats: [
            { value: '7', label: 'Habitaciones Privadas de Hospitalización' },
            { value: '24/7', label: 'Operación Continua' },
            { value: '3', label: 'Áreas Quirúrgicas Dedicadas' },
          ],
        },
        nav: {
          title: 'Descubra Más Sobre CACES',
          subtitle:
            'Conozca nuestra institución, infraestructura y compromiso con la excelencia quirúrgica.',
          btnAbout: 'Más Información Sobre CACES',
          btnFacilities: 'Explore Nuestras Instalaciones',
        },
      },
    },
    specialties: {
      hero: {
        title: 'Especialidades Quirúrgicas',
        subtitle:
          'Atención experta en una amplia gama de disciplinas quirúrgicas.',
      },
      items: {
        general: {
          name: 'Cirugía General',
          desc: 'Procedimientos quirúrgicos integrales para una amplia gama de condiciones abdominales y generales.',
        },
        laparoscopic: {
          name: 'Cirugía Laparoscópica',
          desc: 'Técnicas quirúrgicas mínimamente invasivas utilizando pequeñas incisiones para una recuperación más rápida y menos cicatrices.',
        },
        urological: {
          name: 'Cirugía Urológica',
          desc: 'Tratamiento quirúrgico de condiciones que afectan el tracto urinario y el sistema reproductivo masculino.',
        },
        colorectal: {
          name: 'Cirugía Colorrectal',
          desc: 'Procedimientos especializados para trastornos del recto, ano y colon.',
        },
        oncological: {
          name: 'Cirugía Oncológica',
          desc: 'Tratamiento quirúrgico y extirpación de tumores y tejidos cancerosos.',
        },
        orthopedic: {
          name: 'Cirugía Ortopédica',
          desc: 'Atención quirúrgica para condiciones musculoesqueléticas, incluyendo huesos, articulaciones, ligamentos y tendones.',
        },
        ent: {
          name: 'Otorrinolaringología',
          desc: 'Procedimientos quirúrgicos para condiciones del oído, nariz y garganta (ORL).',
        },
      },
      inquire: 'Consultar sobre esta especialidad',
      disclaimer:
        'Nota Importante: Todos los procedimientos quirúrgicos en CACES son realizados por especialistas independientes afiliados. CACES proporciona la instalación, equipo y personal de apoyo, pero las decisiones clínicas son responsabilidad de su cirujano elegido.',
    },
    specialists: {
      hero: {
        title: 'Especialistas Médicos',
        subtitle:
          'Trabaje con profesionales independientes altamente calificados afiliados a CACES.',
      },
      intro:
        'CACES trabaja con una red de especialistas de confianza que utilizan nuestras instalaciones para brindar atención excepcional. Explore nuestros profesionales afiliados a continuación.',
      btn: 'Solicitar Coordinación',
      disclaimer: {
        title: 'Aviso Importante',
        text: 'Los especialistas médicos presentados son profesionales independientes afiliados a CACES. No son empleados de CACES. Toda la comunicación y coordinación quirúrgica se maneja exclusivamente a través de CACES para garantizar un servicio optimizado.',
      },
      join: {
        title: '¿Es usted un Médico Especialista?',
        desc: 'Únase a nuestra red de profesionales afiliados y opere en uno de los centros ambulatorios más modernos de la región.',
        btn: 'Más Información sobre Operar en CACES',
      },
    },
    patients: {
      hero: {
        title: 'Información para Pacientes',
        subtitle: 'Todo lo que necesita saber sobre su experiencia en CACES.',
      },
      journey: {
        title: 'Su Experiencia en CACES',
        subtitle:
          'Un viaje optimizado desde la consulta hasta la recuperación.',
        steps: {
          consultation: {
            title: 'Consulta',
            desc: 'Evaluación inicial con su especialista.',
          },
          coordination: {
            title: 'Coordinación',
            desc: 'Programación y verificación de seguros con CACES.',
          },
          preparation: {
            title: 'Preparación',
            desc: 'Instrucciones preoperatorias y llegada.',
          },
          surgery: {
            title: 'Cirugía',
            desc: 'Procedimiento en nuestros quirófanos modernos.',
          },
          recovery: {
            title: 'Recuperación',
            desc: 'Recuperación monitoreada y alta.',
          },
        },
      },
      visualJourney: {
        title: 'Preparándose para su Procedimiento',
        subtitle:
          'Un recorrido tranquilo y organizado desde su primer contacto hasta la recuperación.',
        steps: [
          {
            title: 'Contacto Inicial',
            desc: 'Atención médica coordinada desde el inicio.',
          },
          {
            title: 'Evaluación Prequirúrgica',
            desc: 'Una revisión completa en un entorno clínico tranquilo.',
          },
          {
            title: 'Día de Admisión',
            desc: 'Un ambiente seguro y organizado le espera.',
          },
          {
            title: 'Preparación Preoperatoria',
            desc: 'Preparación tranquila antes de su procedimiento.',
          },
          {
            title: 'Recuperación Postquirúrgica',
            desc: 'Comodidad y supervisión durante su recuperación.',
          },
        ],
      },
      international: {
        title: 'Pacientes Internacionales',
        desc: 'CACES da la bienvenida a pacientes de todo el mundo. Entendemos las necesidades únicas del turismo médico y ofrecemos asistencia dedicada para garantizar una experiencia fluida.',
        list: [
          'Coordinación remota con especialistas',
          'Flexibilidad de programación',
          'Apoyo de personal bilingüe',
        ],
      },
      prep: {
        title: 'Preparación para la Cirugía',
        subtitle: 'Pautas Generales',
        list: [
          'Siga las instrucciones de ayuno proporcionadas por su especialista.',
          'Traiga una identificación válida y documentación del seguro.',
          'Organice que un acompañante lo lleve a casa después del alta.',
          'Use ropa cómoda y holgada.',
          'Deje objetos de valor y joyas en casa.',
          'Traiga una lista de medicamentos actuales.',
        ],
      },
      faq: {
        title: 'Preguntas Frecuentes',
        items: [
          {
            q: '¿Qué es CACES?',
            a: 'CACES (Centro Ambulatorio de Cirugía Escalón) es un centro de cirugía ambulatoria privado que proporciona instalaciones de alta calidad y personal de apoyo para procedimientos quirúrgicos realizados por especialistas independientes afiliados.',
          },
          {
            q: '¿Elijo a mi cirujano?',
            a: 'Sí, usted selecciona a su especialista. CACES coordina la logística quirúrgica, el uso de las instalaciones y el apoyo de enfermería, pero la relación médica permanece entre usted y su médico elegido.',
          },
          {
            q: '¿Cuánto tiempo me quedaré?',
            a: 'La mayoría de los procedimientos en CACES son ambulatorios, lo que significa que se va a casa el mismo día. Sin embargo, tenemos 7 habitaciones privadas para hospitalización a corto plazo si su procedimiento o especialista lo requiere.',
          },
          {
            q: '¿CACES está abierto 24/7?',
            a: 'Sí, CACES opera las 24 horas del día, los 7 días de la semana para apoyar cirugías programadas y recuperación postoperatoria.',
          },
          {
            q: '¿Cómo programo un procedimiento?',
            a: 'Puede contactar a nuestro equipo de coordinación directamente a través de este sitio web o por teléfono. Le guiaremos a través del proceso en coordinación con su especialista.',
          },
          {
            q: '¿Aceptan pacientes internacionales?',
            a: 'Sí, damos la bienvenida a pacientes internacionales y brindamos asistencia con la coordinación, incluida la programación y orientación logística local.',
          },
        ],
      },
    },
    contact: {
      hero: {
        title: 'Contáctenos',
        subtitle: 'Estamos aquí para asistirle 24/7.',
      },
      form: {
        title: 'Envíenos un Mensaje',
        name: 'Nombre Completo',
        namePh: 'Su nombre',
        email: 'Correo Electrónico',
        emailPh: 'su@correo.com',
        phone: 'Teléfono',
        phonePh: '+503 ...',
        subject: 'Asunto',
        message: 'Mensaje',
        messagePh: '¿Cómo podemos ayudarle?',
        btn: 'Enviar Mensaje',
        success: {
          title: 'Mensaje Enviado',
          desc: 'Gracias por contactar a CACES. Responderemos a su consulta lo antes posible.',
        },
        subjects: {
          patient: 'Consulta de Paciente',
          coordination: 'Coordinación Quirúrgica',
          specialist: 'Consulta de Especialista',
          general: 'Información General',
        },
      },
      info: {
        title: 'Información de Contacto',
        address: 'Dirección',
        phone: 'Teléfono',
        phoneDesc: 'Disponible 24/7 para coordinación',
        email: 'Correo Electrónico',
        hours: 'Horario',
        hoursDesc: 'Abierto 24 Horas / 7 Días a la Semana',
        map: 'Marcador de Posición del Mapa',
      },
    },
    footer: {
      desc: 'Centro Ambulatorio de Cirugía Escalón. Su salud es nuestra prioridad. Proporcionamos instalaciones de clase mundial para que especialistas independientes realicen procedimientos quirúrgicos avanzados.',
      operating: 'Operando 24/7',
      quickLinks: 'Enlaces Rápidos',
      services: 'Servicios Médicos',
      contact: 'Contáctenos',
      rights: 'Todos los derechos reservados.',
      disclaimer:
        'Aviso: CACES es un centro de cirugía ambulatoria. Los especialistas médicos son profesionales independientes afiliados y no empleados de CACES.',
    },
    modal: {
      title: 'Solicitar Coordinación Quirúrgica',
      success: {
        title: 'Solicitud Recibida',
        desc: 'Gracias por contactar a CACES. Nuestro equipo de coordinación revisará su solicitud y le contactará en breve.',
        close: 'Cerrar',
      },
      form: {
        name: 'Nombre Completo',
        namePh: 'Ingrese su nombre completo',
        email: 'Correo Electrónico',
        emailPh: 'su@correo.com',
        phone: 'Teléfono',
        phonePh: '+503 ...',
        specialty: 'Especialidad de Interés',
        message: 'Mensaje',
        messagePh: '¿Cómo podemos ayudarle?',
        note: 'Nota: CACES es un centro de cirugía ambulatoria. Los especialistas médicos son profesionales independientes afiliados.',
        submit: 'Enviar Solicitud',
        options: {
          general: 'Cirugía General',
          laparoscopic: 'Cirugía Laparoscópica',
          urological: 'Cirugía Urológica',
          colorectal: 'Cirugía Colorrectal',
          oncological: 'Cirugía Oncológica',
          orthopedic: 'Cirugía Ortopédica',
          ent: 'Otorrinolaringología',
          other: 'Otro / Consulta General',
        },
      },
    },
    specialistForm: {
      title:
        'Plataforma Quirúrgica CACES – Portal de Coordinación para Especialistas',
      subtitle:
        'CACES proporciona un entorno quirúrgico ambulatorio completamente equipado para especialistas médicos independientes. Utilice este portal institucional para coordinar procedimientos quirúrgicos dentro de nuestra instalación certificada.',
      success: {
        title: 'Solicitud Recibida',
        desc: 'Gracias. Su solicitud de coordinación quirúrgica ha sido recibida por el equipo administrativo de CACES. Nuestro equipo le contactará en breve para confirmar detalles y disponibilidad.',
        close: 'Cerrar',
      },
      section1: {
        title: 'I. Credenciales Profesionales',
        name: 'Nombre Completo',
        namePh: 'Ingrese su nombre completo',
        license: 'Número de Licencia Profesional / Junta de Vigilancia',
        licensePh: 'Ingrese su número de licencia o identificación médica',
        specialty: 'Especialidad',
        institution: 'Institución o Clínica de Origen',
        institutionPh: 'Hospital, clínica o práctica privada (opcional)',
        email: 'Correo Electrónico',
        emailPh: 'su@correo.com',
        phone: 'Número de Teléfono',
        phonePh: '+503 ...',
        requestType: 'Tipo de Solicitud',
        requestTypeOptions: {
          placeholder: 'Seleccione tipo de solicitud',
          firstTime: 'Primera coordinación quirúrgica',
          returning: 'Especialista recurrente',
          regular: 'Interesado en acceso quirúrgico regular',
        },
      },
      section2: {
        title: 'II. Planificación Quirúrgica',
        surgicalSpecialty: 'Especialidad Quirúrgica a Coordinar',
        procedure: 'Nombre o Descripción del Procedimiento',
        procedurePh: 'Describa el procedimiento quirúrgico',
        duration: 'Duración Estimada del Procedimiento',
        durationPh: 'ej., 2 horas',
        durationOptions: {
          placeholder: 'Seleccione duración estimada',
          under1: 'Menos de 1 hora',
          one2: '1–2 horas',
          two3: '2–3 horas',
          three4: '3–4 horas',
          over4: 'Más de 4 horas',
        },
        date: 'Fecha Preferida de Cirugía',
        hospitalization: 'Días Estimados de Hospitalización',
        hospitalizationPh: 'Número de días',
        hospitalizationNote:
          'CACES opera como un centro de cirugía ambulatoria. La hospitalización extendida requiere autorización previa.',
      },
      section3: {
        title: 'III. Requisitos Técnicos e Institucionales',
        requirements: 'Requisitos Especiales u Observaciones',
        requirementsPh: 'Equipo especial, personal o condiciones necesarias...',
        documents: 'Adjuntar Documentos Relevantes',
        documentsNote:
          'ej., notas médicas, detalles del procedimiento — no se requieren identificadores de pacientes',
        documentsBtn: 'Seleccionar Archivo',
        noFile: 'Ningún archivo seleccionado',
        reviewNote:
          'Nuestro equipo de coordinación quirúrgica revisa todos los requisitos técnicos para garantizar la preparación completa del quirófano.',
      },
      section4: {
        title: 'IV. Confirmación Institucional',
        checkbox:
          'Confirmo que soy un médico especialista independiente y entiendo que todas las decisiones clínicas permanecen bajo mi exclusiva responsabilidad profesional. CACES proporciona infraestructura, equipamiento quirúrgico y equipos de apoyo clínico certificados.',
      },
      whyOperate: {
        title: '¿Por Qué Operar en CACES?',
        items: [
          'Quirófanos completamente equipados',
          'Equipos de apoyo quirúrgico certificados',
          'Eficiencia quirúrgica ambulatoria',
          'Protocolos de seguridad institucional',
          'Autonomía profesional respetada',
        ],
      },
      submit: 'Enviar Solicitud Quirúrgica Institucional',
      note: 'CACES es un centro de cirugía ambulatoria. Todos los procedimientos son realizados por especialistas médicos independientes que mantienen plena responsabilidad clínica. CACES proporciona infraestructura, equipamiento y equipos de apoyo quirúrgico.',
    },
  },
}
